import './App.css';
import Chat from "./components/Chat.jsx"

function App() {
  return (
    <div className="App">
      <Chat/>
    </div>
  );
}

export default App;
